import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  detailPanel: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
  },
  containerCampos: {
    paddingBottom: theme.spacing(3),
    borderLeft: '1px solid #CCC',
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      borderLeft: 'none',
      paddingLeft: 0,
    },
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  field: {
    marginTop: theme.spacing(1),
  },
  tituloSecao: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2.5),
  },
  botaoSalvar: {
    marginTop: '20px',
    marginBottom: '40px',
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: 0,
      '& button': {
        width: '100%',
      },
    },
  },
}))
